package fr.frux.core.network.api

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.network.ApiPaths
import fr.frux.shared.dto.SupportDonateUrlResponse
import fr.frux.shared.dto.SupportPromptResponse
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.get
import io.ktor.client.request.parameter
import io.ktor.client.request.post

/**
 * Cagnotte de dons (spec 2026-08-13). Le client ne porte aucune règle : il demande, il affiche.
 */
interface SupportApi {
    suspend fun getPrompt(platform: String): SupportPromptResponse

    suspend fun markPromptShown()

    suspend fun optOut()

    /** URL de don signée, rattachée au compte connecté (#319). */
    suspend fun getDonateUrl(): SupportDonateUrlResponse
}

@ContributesBinding(AppScope::class)
@SingleIn(AppScope::class)
@Inject
class SupportApiImpl(
    private val httpClient: HttpClient,
) : SupportApi {
    override suspend fun getPrompt(platform: String): SupportPromptResponse =
        httpClient
            .get("${ApiPaths.V1}/support/prompt") {
                parameter("platform", platform)
            }.body()

    override suspend fun markPromptShown() {
        httpClient.post("${ApiPaths.V1}/support/prompt/shown")
    }

    override suspend fun optOut() {
        httpClient.post("${ApiPaths.V1}/support/opt-out")
    }

    override suspend fun getDonateUrl(): SupportDonateUrlResponse =
        httpClient
            .get("${ApiPaths.V1}/support/donate-url")
            .body()
}
